import { isNotNilOrEmpty } from '@@serverHelpers';
import { dateTsToFr } from '@@viewHelpers/date';
import { modifyPath, when } from 'ramda';

export const extraFormatProject = modifyPath(
  ['company', 'creationDate'],
  when(isNotNilOrEmpty, dateTsToFr)
);
